'use client'

import { useMemo } from 'react'

import { useIntl } from 'react-intl'

import {
  DropdownWithoutLabel,
  DropdownWithoutLabelSize,
} from '@b-stock/fe-core/bstock-react'

import { useListingSearch } from '@/components/listings/search/ListingSearchProvider'
import {
  PAGE_SIZE_OPTIONS,
  writeRememberedPageSize,
} from '@/components/listings/search/ListingSearchProvider/rememberedPageSize'
import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'

const PerPageDropdown = () => {
  const { isPageSizeRemembered, setPageSize, state } = useListingSearch()
  const { formatMessage } = useIntl()
  const { trackButtonClicked } = useAnalytics()

  const perPageOptions = useMemo(
    () =>
      PAGE_SIZE_OPTIONS.map((value) => ({
        label: formatMessage({ id: `Filters.nPerPage` }, { n: value }),
        value: `${value}`,
      })),
    [formatMessage]
  )

  const handleChange = (value: string) => {
    const selectedOption = perPageOptions.find(
      (option) => option.value === value
    )

    trackButtonClicked({
      buttonName: 'number_of_listings_alp',
      filter_title: 'number_of_listings_dropdown',
      filter_name: selectedOption?.label || value,
    })

    const pageSize = parseInt(value)
    if (isPageSizeRemembered) writeRememberedPageSize(pageSize)
    setPageSize(pageSize)
  }

  return (
    <DropdownWithoutLabel
      size={DropdownWithoutLabelSize.narrow}
      value={state.pageSize.toString()}
      onChange={handleChange}
      options={perPageOptions}
    />
  )
}

export default PerPageDropdown
